import React, { useContext } from 'react'
import styled from 'styled-components'
import media from 'css-in-js-media'
import LocalLink from './LocalLink'
import LayoutContext from './LayoutContext'
import { Variables } from '../styles/Variables'

export const StyledNavigation = styled.div`
    flex-grow: 5;
    margin-left: 60px;
 
    ${media('>=desktop')} {
        text-align: right;
        white-space: nowrap;
    }

    a {
        margin: 0;
        margin-right: 25px;
        color: ${Variables.color.white};
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.001em;
        font-size: 18px;
        line-height: 24px;
        padding-bottom: 2px;
        border-bottom: 2px solid transparent;

        &:hover {
            border-color: ${Variables.color.white};
        }

        ${media('<desktop')} {
            padding-left: 20px;
        }
    }

    a.active {
        border-color: ${Variables.color.white};
        ${media('<desktop')} {
            border-left: 6px solid ${Variables.color.white};
            border-bottom: none;   
            padding-left: 17px;   
        }
    }    
`

const Navigation = ({ data }) => {
    const { currentLang } = useContext(LayoutContext)    
    const headerData =
        data && data.allContentfulHeader.edges.find((i) => i.node.node_locale == currentLang.langKey).node
    return (
        <>
            {headerData && (
                <StyledNavigation>
                    {headerData.links &&
                        headerData.links.map((link, i) => {
                            const isActive = currentLang?.link.includes(link.slug);                            
                            return (
                                <LocalLink className={isActive ? 'active' : null} key={i} to={link.slug}>
                                    {link.title}
                                </LocalLink>
                            )
                        })}
                </StyledNavigation>
            )}
        </>
    )
}

export default Navigation
